import {
  AnalyticsViewType,
  ExperienceDevicePreviewDto,
  GetExperienceResponseBodyType,
  PatchExperienceResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { experienceKeys } from "../queryKeys";

const patchExperience = async (
  id: string,
  analyticsViewType?: AnalyticsViewType,
  devicePreview?: ExperienceDevicePreviewDto,
  isPreview?: boolean
): Promise<PatchExperienceResponseBodyType> => {
  const resp = await api.patch<PatchExperienceResponseBodyType>(
    `/v2/experiences/${id}`,
    {
      id,
      analyticsViewType,
      devicePreview,
      isPreview,
    }
  );
  return resp.data;
};

export const usePatchExperience = (experienceId?: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["mutatePatchExperience"],
    mutationFn: async (data: {
      id: string;
      analyticsViewType?: AnalyticsViewType;
      devicePreview?: ExperienceDevicePreviewDto;
      isPreview?: boolean;
    }) =>
      patchExperience(
        data.id,
        data.analyticsViewType,
        data.devicePreview,
        data.isPreview
      ),
    onSuccess: async (data) => {
      experienceId &&
        queryClient.setQueryData(experienceKeys.one(experienceId), {
          experience: data.experience,
        });
    },
  });
};
